import React from "react";
import {
  DisplayShortCode
} from "../../_metronic/_partials";

export function DShortCode(props) {
  return <DisplayShortCode {...props} />;
}
